import { DEFAULT_LOCALE } from '~/lib/constants'

import { getIntlLocale } from '~/utils/locales'

export default function serializePrice(
  locale: string = DEFAULT_LOCALE,
  currencyCode: string,
  amount: number,
): string {
  if (!locale || !currencyCode || isNaN(amount)) {
    console.error('Something went wrong with the price serialization.')
    return null
  }

  const intl = getIntlLocale(locale)
  const roundedAmount = Math.round(amount)
  return (
    new Intl.NumberFormat(intl, {
      style: 'currency',
      currency: currencyCode,
      useGrouping: true,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    })
      .format(Number(roundedAmount))
      // Remove unbreakable space
      .replace(/\u00a0/g, '')
  )
}
